import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';
import { Admin } from 'app/model';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';

@Component({
  selector: 'insol-select-job',
  templateUrl: './select-job-form-field.component.html',
})
export class SelectJobFormFieldComponent implements OnChanges {
  @Input() appearance: string;
  @Input() jobs: Admin[];
  @Input() disabled: boolean;

  @Input() selectedJobId: number;
  @Input() includeInactiveJobs: boolean;
  @Output() selectedJobIdChange = new EventEmitter<number>();
  @Output() includeInactiveJobsChange = new EventEmitter<boolean>();
  @Output() clearJob = new EventEmitter<void>();

  filterValue$ = new BehaviorSubject<string>(null);
  filteredJobs$: Observable<Admin[]>;

  private jobs$ = new BehaviorSubject<Admin[]>([]);

  inactiveJobToggle: boolean;

  constructor() {
    this.inactiveJobToggle = environment.jobSelectInactiveJobToggle || false;

    this.filteredJobs$ = combineLatest([this.filterValue$, this.jobs$]).pipe(
      map(([filterValue, jobs]) => {
        if (!filterValue) {
          return jobs;
        }

        filterValue = filterValue.toLowerCase();
        return jobs.filter((j) => j.name.toLowerCase().includes(filterValue));
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobs']) {
      this.jobs$.next(this.jobs || []);
    }

    if (changes['selectedJobId'] || changes['jobs']) {
      const selectedJob = this.jobs?.find((job) => job.adminId === this.selectedJobId);
      this.filterValue$.next(selectedJob?.name);
    }

    if (!this.inactiveJobToggle && changes['includeInactiveJobs']) {
      // Enforce always true if that inactive job toggle isn't available
      if (!this.includeInactiveJobs) {
        console.info('Include inactive job defaulted to false when toggle is excluded. Changing...');
        this.toggleIncludeInactiveJobs();
      }
    }
  }

  select(job: Admin, event: MatOptionSelectionChange): void {
    if (event.isUserInput) {
      if (job && event.source.selected) {
        this.selectedJobIdChange.next((this.selectedJobId = job.adminId));
      } else {
        this.selectedJobIdChange.next((this.selectedJobId = null));
      }
    }
  }

  toggleIncludeInactiveJobs(): void {
    this.includeInactiveJobs = !this.includeInactiveJobs;
    this.includeInactiveJobsChange.emit(this.includeInactiveJobs);
  }

  includeInactiveJobsChanged(change: MatCheckboxChange): void {
    this.includeInactiveJobsChange.emit(change.checked);
  }
}
